import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.jsx";
import { Link } from "react-router-dom";

const styles = (theme) => ({
  policyFooter: {
    background: `rgba(0, 0, 0, 0.8)`,
    padding: "20px 40px",
    display: "flex",
    color: "#fff",
    alignItems: "center",
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: 10,
    width: "100%",
    fontSize: "clamp(0.6rem, -0.875rem + 1.8vw, 2rem)",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "fit-content",
      top: "30%",
    },
  },
  message: {
    flex: " 1 1 50%",
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
  },
  title: {
    flex: "1 1 10%",
    fontSize: "24px",
    lineHeight: "32px",
    minWidth: "320px",
    padding: "12px 40px 12px 0",
    margin: "0 40px 0 0",
    borderRight: "3px solid #fff",
    [theme.breakpoints.down("md")]: {
      padding: 0,
      margin: 0,
      borderRight: 0,
      minWidth: 0,
    },
  },
  btnWrapper: {
    flex: "0 1 20%",
    paddingLeft: "20px",
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
      flex: "0 1 50%",
    },
  },
});

console.log("testing 3");

function CookiesConsent({ setCookies, cookieName, classes }) {
  return (
    <footer className={classes.policyFooter} id="cookies-policy-footer">
      <p className={classes.title}>This site uses cookies</p>
      <p className={classes.message}>
        These cookies are used to collect information about how you interact
        with our website and allow us to remember you. We use this information
        in order to improve and customize your browsing experience and for
        analytics and metrics. For information about our cookies, see our{" "}
        <Link to="/cookie-policy">
          <span>Cookie policy.</span>
        </Link>{" "}
        Read about our Privacy policy{" "}
        <Link to="/privacy-policy">
          <span>here.</span>{" "}
        </Link>
      </p>
      <div className={classes.btnWrapper}>
        <Button
          color="info"
          outline
          onClick={() => setCookies(cookieName, true, 365)}
        >
          <span className={classes.btnText}>Accept.</span>
        </Button>
      </div>
    </footer>
  );
}

export default withStyles(styles)(CookiesConsent);



// WEBPACK FOOTER //
// ./src/views/policies/cookies-consent.js